<template>
  <div class="o-listing-card o-listing-card--landing">
    <div class="row">
      <div class="simplefavorite-button-container">
        <button class="simplefavorite-button reverse fav-plugin o-favourite-button" :data-postid="content.id" data-siteid="1" data-groupid="1" data-favoritecount="2" style=""><i class="sf-icon-star-empty"></i></button>
      </div>
      <div class="o-listing-card__picture u-bg-img columns medium-4" :style="'background-image: url('+content.listing_image+');'" aria-hidden="true" role="presentation" data-equalizer-watch v-if="content.listing_image"></div>
      <div class="o-listing-card__picture u-bg-img columns medium-4" style="background-image: url('/wp-content/themes/visitwaterford/assets/images/default-image.png');" aria-hidden="true" role="presentation" v-else></div>
      <div class="o-listing-card__text columns medium-8">
        <h3 class="o-listing-card__title"><a :href="content.listing_link">{{content.title}}</a></h3>
        <div class="o-listing-card__categories">
          <!-- <a :href="cat.link" v-for="(cat,key,index) of content.categories">
            {{ cat.name }}
            <span v-if="index != Object.keys(content.categories).length - 1"> | </span>
          </a> -->
          <a :href="cat.link" v-for="(cat,key) of content.categories" v-if="key <= 5">
            {{ cat.name }}
            <span v-if="key == Object.keys(content.categories).length - 1"></span>
            <span v-else-if="key == 5">...</span>
            <span v-else> | </span>
          </a>
        </div>
        <div class="o-listing-card__interactions row small-collapse">
          <div class="o-listing-card__location columns small-8" v-if="content.locations.length"><a :href="location.link" v-for="location in content.locations.slice(0,1)">{{ location.name }}</a></div>
          <div class="o-listing-card__button columns u-right" :class="{'small-4': content.locations.length, 'small-12': !content.locations.length }">
            <a :href="content.listing_link" class="button button--small">View</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {

    name: 'ListingCard',

    props: {
      content: {
        type: Object,
      }
    },

    mounted () {
      this.callFoundation();
    },

    methods: {
        // Renit foundation components
      callFoundation () {
        this.$nextTick(() => {
          $(this.$el).foundation();
        })
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/js/vue/vue-partials/listing-card.vue